import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Chip, Stack, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { useLanguage } from "../../context/LanguageContext";
import axios from "axios";

const categories = [
  "Forex Trading",
  "Cryptocurrencies",
  "Stock Derivatives",
  "Turbo Stocks",
  "Commodities",
  "Equity Indices",
  "Precious Metals",
  "Energies",
  "Shares",
  "Thematic Indices",
];

type TradingProps = {
  titleLine1: string,
  titleLine2: string,
};

export const Trading: React.FC<TradingProps> = ({
  titleLine1,
  titleLine2,
  subtitle,
  active,
  banner,
}) => {
  const navigate = useNavigate();

  const { language, translations } = useLanguage();
  const [flagUrl, setFlagUrl] = useState(""); 

  useEffect(() => {
    const fetchCountryCode = async () => {
      try {
        const response = await axios.get("https://ipwhois.app/json/");
        const ipCountryCode = response.data.country; // e.g., 'IN'

        console.log("sdfsdfsdfsa", ipCountryCode);

        setFlagUrl(ipCountryCode);
      } catch (error) {
        console.error("Failed to fetch IP info:", error);
      }
    };

    fetchCountryCode();
  }, []);

  const categories = [
    { name: translations[language]?.optionsTab?.name, route: "/forex-trading" },
    ...(flagUrl !== "Lebanon"
      ? [{ name: translations[language]?.optionsTab?.name1, route: "/cryptocurrencies" }]
      : []),

    // {
    //   name: translations[language]?.optionsTab?.name1,
    //   route: "/cryptocurrencies",
    // },
    {
      name: translations[language]?.optionsTab?.name2,
      route: "/stock-derivatives",
    },
    // { name: "Turbo Stocks", route: "#" },
    { name: translations[language]?.optionsTab?.name3, route: "/commodities" },
    { name: translations[language]?.optionsTab?.name4, route: "/equity" },
    {
      name: translations[language]?.optionsTab?.name5,
      route: "/precious-metals",
    },
    { name: translations[language]?.optionsTab?.name6, route: "/energies" },
    { name: translations[language]?.optionsTab?.name7, route: "/shares" },
    // { name: "Thematic Indices", route: "#" },
  ];

  const handleNavigate = (label) => {
    // const path = `/${label.toLowerCase().replace(/\s+/g, "-")}`;
    navigate(label);
  };

  useEffect(() => {
    AOS.init({
      duration: 1000, // default animation duration
      once: false, // whether animation should happen only once
    });
  }, []);
  const narrowSubtitles = [
    "Trade soft Commodities like coffee and sugar with excellent conditions.",
    "Trade oil and gas variants with low costs and competitive conditions.",
  ];

  const width = narrowSubtitles.includes(subtitle) ? "600px" : "700px";
  return (
    <Box
      pt={{ xs: 12, md: 15 }}
      sx={{
        backgroundImage: `url(${banner}), linear-gradient(to right, #ffffff 0%, #ffffff 0%, #eff7ff 82%)`,
        backgroundRepeat: "no-repeat",
        backgroundSize: { xs: "cover", md: "cover" },
        backgroundPosition: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 2,
        textAlign: "center",
        imageRendering: "auto",
        height: { xs: "auto", md: "100vh" },
      }}
    >
      <Box>
        <Box
        // data-aos="zoom-in"
        >
          <Typography variant="h2" style={{ fontSize: '80px', lineHeight: '81px' }} fontWeight="bold">
            {titleLine1}
            <br />
            {titleLine2}
          </Typography>
        </Box>

        <Box>
          <Typography
            sx={{
              fontSize: "22px",
              color: "#212529c4",
              fontWeight: "500",
              fontFamily: "SF Pro Display",
              mt: 3,
              mx: "auto",
              width: {
                xs: "100%",
                md: width,
              },
            }}
          >
            {subtitle}
          </Typography>
        </Box>

        <Button
          disableRipple
          component="a"
          href="https://portal.bbcorp.trade/auth/jwt/sign-up/" // ← your actual link here
          target="_blank"
          rel="noopener noreferrer"
          variant="contained"
          sx={{
            backgroundColor: "#000",
            color: "#fff",
            textTransform: "none",
            px: 4,
            py: 2,
            borderRadius: "8px",
            fontSize: "16px",
            mb: 4,
            boxShadow: "none",
            mt: 4,
            color: "rgba(255, 255, 255, 1)",
            "&:hover": {
              backgroundColor: "#000",
              color: "#fff",
              boxShadow: "none",
            },
            "&:active": {
              boxShadow: "none", // 🛑 no shadow on click
            },
          }}
        >
          {translations[language]?.tradingNew?.tradingBTN}
        </Button>
        <Container maxWidth="lg">
          <Box mb={6}>
            <Stack
              direction="row"
              flexWrap="wrap"
              justifyContent="center"
              gap={1.7}
              mt={4}
            >
              {categories?.map((label) => (
                <Chip
                  key={label?.name}
                  clickable={false}
                  onClick={() => handleNavigate(label?.route)}
                  label={label?.name}
                  variant={label?.name === active ? "filled" : "none"}
                  sx={{
                    bgcolor: label?.name === active ? "#2494c947" : "#e9ecef91",
                    color: label?.name === active ? "#2494C9" : "#667085",
                    fontWeight: 500,
                    px: { xs: 1.5, sm: 2 },
                    fontSize: { xs: "12px", sm: "14px", md: "16px" },
                    height: { xs: 34, sm: 40, md: 45 },
                    borderRadius: "15px",
                    cursor: "pointer",
                    backdropFilter: label?.name === active ? "blur(2px)" : "blur(2px)",
                    WebkitBackdropFilter: label?.name === active ? "blur(2px)" : "blur(2px)",
                  }}
                // sx={{
                //   bgcolor: label?.name === active ? "#2494c947" : "#e9ecef91",
                //   color: label?.name === active ? "#2494C9" : "#667085",
                //   fontWeight: 500,
                //   px: { xs: 1.5, sm: 2 },
                //   fontSize: { xs: "12px", sm: "14px", md: "16px" },
                //   height: { xs: 34, sm: 40, md: 45 },
                //   borderRadius: "15px",
                //   cursor: "pointer",
                // }}
                />
              ))}
            </Stack>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};
